import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, ref, watchEffect } from 'vue';
import { GenericPodProduct } from './typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSelector',
  props: {
    products: { default: () => [] },
    value: { default: () => [] }
  },
  emits: ['input', 'product-select', 'product-unassign'],
  setup(__props: any, { emit }) {

const props = __props as { products: GenericPodProduct[], value: GenericPodProduct[] };





const thumbsProps = {
    width: 50,
    height: 50
};
let internalSelectedProducts: GenericPodProduct[] = [];
const productsPerPage = 10;
const searchString = ref('');
const currentPage = ref(1);
const totalCount = ref(0);
const filteredProducts: Ref<GenericPodProduct[]> = ref([]);

const selectedProducts = computed({
    get(): GenericPodProduct[] {
        return props.value;
    },
    set(value: GenericPodProduct[]) {
        internalSelectedProducts = value;
        emit('input', value);
    }
});

watchEffect(() => {
    if (!props.products) return [];

    let filtered = props.products;

    if (searchString.value.length) {
        const searchValue = searchString.value.trim().toLowerCase();
        // Filter by search string
        filtered = filtered.filter(
            (p) =>
                p.title.toLowerCase().includes(searchValue) ||
                (p.description && p.description.toLowerCase().includes(searchValue))
        );
    }

    totalCount.value = filtered.length;
    // Filter by pagination
    const startIndex = (currentPage.value - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    filteredProducts.value = filtered.slice(startIndex, endIndex);
});

const updateSearchString = (value: string) => {
    searchString.value = value;
};

const onProductSelect = (product: GenericPodProduct) => {
    if (!internalSelectedProducts.some((p) => p.id === product.id)) {
        internalSelectedProducts.push(product);
    }
    emit('input', internalSelectedProducts);
    emit('product-select', product);
};

const onUnassign = (product: GenericPodProduct) => {
    const index = internalSelectedProducts.findIndex((p) => p.id === product.id);
    if (index > -1) {
        internalSelectedProducts.splice(index, 1);
    }
    emit('input', internalSelectedProducts);
    emit('product-unassign', product);
};

return { __sfc: true,emit, props, thumbsProps, internalSelectedProducts, productsPerPage, searchString, currentPage, totalCount, filteredProducts, selectedProducts, updateSearchString, onProductSelect, onUnassign }
}

})